import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

/**
 * CavazosTurquoise - Preset personalizado marca Cavazos
 * 
 * Paleta basada en Turquesa (#4FD1C5) para mantener consistencia con la App Móvil.
 * 
 */
export const CavazosTurquoise = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#F0FDFA',
            100: '#CCFBF1',
            200: '#99F6E4',
            300: '#5EEAD4',
            400: '#4FD1C5', // Main Brand Color adjusted to scale
            500: '#2DD4BF', // Slightly darker for better visibility on white
            600: '#0D9488',
            700: '#0F766E',
            800: '#115E59',
            900: '#134E4A',
            950: '#042F2E'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '#0D9488', // Teal 600 for text contrast on buttons
                    contrastColor: '#ffffff',
                    hoverColor: '#0F766E',
                    activeColor: '#115E59'
                },
                highlight: {
                    background: '#F0FDFA',
                    focusBackground: '#CCFBF1',
                    color: '#134E4A',
                    focusColor: '#134E4A'
                }
            },
            dark: {
                primary: {
                    color: '#4FD1C5',
                    contrastColor: '#042F2E',
                    hoverColor: '#5EEAD4',
                    activeColor: '#2DD4BF'
                },
                highlight: {
                    background: 'rgba(79, 209, 197, 0.16)',
                    focusBackground: 'rgba(79, 209, 197, 0.24)',
                    color: 'rgba(255, 255, 255, 0.87)',
                    focusColor: 'rgba(255, 255, 255, 0.87)'
                }
            }
        }
    }
});
